import c from "./ghl-ui.es1589.js";
import u from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import p from "./ghl-ui.es1587.js";
import f from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
import { numericPatterns as d } from "./ghl-ui.es1672.js";
import { parseNDigits as h, parseNumericPattern as v } from "./ghl-ui.es1671.js";
var S = /* @__PURE__ */ function(m) {
  p(a, m);
  var i = f(a);
  function a() {
    var o;
    c(this, a);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return o = i.call.apply(i, [this].concat(e)), n(s(o), "priority", 50), n(s(o), "incompatibleTokens", ["t", "T"]), o;
  }
  return u(a, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "s":
          return v(d.second, r);
        case "so":
          return t.ordinalNumber(r, {
            unit: "second"
          });
        default:
          return h(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 0 && e <= 59;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return r.setUTCSeconds(t, 0), r;
    }
  }]), a;
}(l);
export {
  S as SecondParser
};
